import { useState } from "react";
import api, { API } from "@/lib/api";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { toast } from "sonner";

const REPORTS = [
  { id: "monthly_sales", title: "Monthly Sales Summary" },
  { id: "agent_performance", title: "Agent Sales Performance" },
  { id: "state_performance", title: "State Sales Performance" },
  { id: "customer_activity", title: "Customer Activity" },
  { id: "no_sale", title: "No-Sale Customers" },
  { id: "inactive", title: "Inactive Customers" },
  { id: "store_visits", title: "Store Visit Report" },
  { id: "tasks", title: "Follow-up Tasks" },
];

export default function Reports() {
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7));

  const download = async (id, fmt, title) => {
    try {
      const r = await api.get(`/reports/${id}`, { params: { fmt, month }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url; a.download = `${title}.${fmt === "xlsx" ? "xlsx" : "pdf"}`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Report failed"); }
  };
  return (
    <div className="space-y-6" data-testid="reports-page">
      <div className="flex justify-between items-end flex-wrap gap-3">
        <div><h1 className="text-3xl sm:text-4xl font-heading font-black tracking-tight">Reports</h1><p className="text-slate-600">Download Excel or PDF</p></div>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-11 px-3 border border-slate-300 rounded-lg" data-testid="report-month" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map(r => (
          <div key={r.id} className="bg-white rounded-xl border border-slate-200 p-5 card-hoverable" data-testid={`report-${r.id}`}>
            <div className="text-lg font-heading font-semibold">{r.title}</div>
            <div className="flex gap-2 mt-4">
              <button onClick={() => download(r.id, "xlsx", r.title)} className="flex-1 h-10 rounded-lg border border-slate-300 text-sm font-semibold flex items-center justify-center gap-2 hover:border-[#003DA5]"><FileSpreadsheet className="w-4 h-4 text-emerald-600" />Excel</button>
              <button onClick={() => download(r.id, "pdf", r.title)} className="flex-1 h-10 rounded-lg border border-slate-300 text-sm font-semibold flex items-center justify-center gap-2 hover:border-[#003DA5]"><FileText className="w-4 h-4 text-red-600" />PDF</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
